import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import cls from 'classnames/bind';
import s from './LoadingDots.scss';

const cx = cls.bind(s);

class LoadingDots extends PureComponent {
  static propTypes = {
    isWhite: PropTypes.bool,
    theme: PropTypes.string,
    itemClassName: PropTypes.string,
  };
  static defaultProps = {};

  render() {
    const { theme, isWhite, itemClassName, className } = this.props;

    return (
      <div
        className={cx(
          'LoadingDots',
          {
            'LoadingDots--isWhite': isWhite,
            [`LoadingDots--theme-${theme}`]: Boolean(theme),
          },
          className
        )}
      >
        <span className={cx('LoadingDots__item', 'LoadingDots__item--isFirst', itemClassName)} />
        <span className={cx('LoadingDots__item', 'LoadingDots__item--isSecond', itemClassName)} />
        <span className={cx('LoadingDots__item', 'LoadingDots__item--isThird', itemClassName)} />
      </div>
    );
  }
}

export default LoadingDots;
